import { useState } from "react";

import { Button } from "@/components/ui/buttons/Button";
import styles from "@/pages/LoginPage/AdfsLoginForm/AdfsLoginForm.module.css";
import { LoginError } from "@/pages/LoginPage/AdfsLoginForm/LoginError";
import { LoginForm } from "@/pages/LoginPage/AdfsLoginForm/LoginForm";
import { AdfsLoginFormVariant, FormValues, LoginErrorType } from "@/pages/LoginPage/AdfsLoginForm/login-page.types";
import { login } from "@/services/auth/adfs.service";
import { AuthError } from "@/services/auth/auth.errors";
import { useAppDispatch } from "@/store";
import { authenticate } from "@/store/slices/auth.slice";

type Props = {
    variant: AdfsLoginFormVariant;
};

const AdfsLoginForm = (props: Props) => {
    const { variant } = props;

    const [showLoginForm, setShowLoginForm] = useState(false);
    const [error, setError] = useState<LoginErrorType | null>(null);
    const dispatch = useAppDispatch();

    const handleLogin = async (data: FormValues) => {
        setError(null);

        try {
            const res = await login(data);
            dispatch(authenticate({ authStrategy: "adfs", authData: res }));
        } catch (err) {
            if (err instanceof AuthError) {
                if (err.data?.error_description === "Your user name or password is invalid.") {
                    setError("invalidLogin");
                } else if (err.data?.error_description === "Too many login attempts. Please try again later.") {
                    setError("tooManyLoginAttempts");
                } else if (err.data?.error_description === "Your password has expired.") {
                    setError("expiredPassword");
                } else {
                    setError("serverError");
                }
            } else {
                setError("serverError");
            }
        }
    };

    if (variant === "buttonAndForm" && !showLoginForm) {
        return (
            <Button
                className={styles.button_show_form}
                size="lg"
                variant="text"
                onClick={() => setShowLoginForm(!showLoginForm)}
            >
                Log in with Credentials
            </Button>
        );
    }

    return (
        <>
            {error && <LoginError type={error} />}

            <div>
                <LoginForm onSubmit={handleLogin} />
            </div>
        </>
    );
};

export { AdfsLoginForm };
